if (!customElements.get('wls-testimonials')) {
  class WlsTestimonials extends HTMLElement {
    constructor() {
      super();
      this.desktopMin = 1024;
      this.mobileSwiperMinSlides = 2;
      this.boundOnResize = this.onResize.bind(this);
      this.boundOnTabClick = this.onTabClick.bind(this);
    }

    getDesktopColumns() {
      const v = parseInt(this.getAttribute('data-desktop-columns'), 10);
      if (Number.isFinite(v) && v >= 3 && v <= 5) return v;
      return 4;
    }

    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('.js-wls-testimonials-panel'));
      this.tabButtons = Array.from(this.querySelectorAll('.js-wls-testimonials-tab'));
      this.tabButtons.forEach((btn) => btn.addEventListener('click', this.boundOnTabClick));
      window.addEventListener('resize', this.boundOnResize);

      const active = this.panels.find((p) => p.classList.contains('is-active')) || this.panels[0];
      if (active) {
        requestAnimationFrame(() => this.refreshPanel(active, true));
      }
    }

    disconnectedCallback() {
      this.tabButtons.forEach((btn) => btn.removeEventListener('click', this.boundOnTabClick));
      window.removeEventListener('resize', this.boundOnResize);
      this.panels.forEach((panel) => this.destroySwiper(panel));
    }

    onTabClick(event) {
      const btn = event.currentTarget;
      const index = Number(btn.getAttribute('data-tab-index'));
      if (Number.isNaN(index)) return;

      this.tabButtons.forEach((b) => {
        const idx = Number(b.getAttribute('data-tab-index'));
        const on = idx === index;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach((panel, i) => {
        const isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      const panel = this.panels[index];
      if (panel) {
        requestAnimationFrame(() => this.refreshPanel(panel, true));
      }
    }

    onResize() {
      this.panels.forEach((panel) => {
        this.refreshPanel(panel, false);
      });
    }

    slideCount(panel) {
      return panel.querySelectorAll('.js-wls-testimonials-slide').length;
    }

    needsSwiper(panel) {
      const n = this.slideCount(panel);
      if (n < this.mobileSwiperMinSlides) return false;
      if (window.innerWidth >= this.desktopMin) {
        return n > this.getDesktopColumns();
      }
      return true;
    }

    destroySwiper(panel) {
      if (panel._wlsSwiper) {
        try {
          panel._wlsSwiper.destroy(false, false);
        } catch (e) {
          /* ignore */
        }
        panel._wlsSwiper = null;
      }
      const root = panel.querySelector('.js-wls-testimonials-swiper');
      const controls = panel.querySelector('.js-wls-testimonials-controls');
      if (root) root.classList.add('wls-testimonials__swiper--static');
      if (controls) controls.hidden = true;
    }

    refreshPanel(panel, forceUpdate) {
      if (typeof Swiper === 'undefined') return;

      const root = panel.querySelector('.js-wls-testimonials-swiper');
      const controls = panel.querySelector('.js-wls-testimonials-controls');
      const prevEl = panel.querySelector('.js-wls-testimonials-prev');
      const nextEl = panel.querySelector('.js-wls-testimonials-next');
      const paginationEl = panel.querySelector('.js-wls-testimonials-pagination');
      if (!root) return;

      const isActive = panel.classList.contains('is-active') && !panel.hidden;
      const want = this.needsSwiper(panel);

      if (!want) {
        this.destroySwiper(panel);
        return;
      }

      if (!isActive) {
        if (panel._wlsSwiper) {
          try {
            panel._wlsSwiper.update();
          } catch (e) {
            /* ignore */
          }
        }
        return;
      }

      if (controls) controls.hidden = false;
      root.classList.remove('wls-testimonials__swiper--static');

      if (!panel._wlsSwiper) {
        const deskCols = this.getDesktopColumns();
        panel._wlsSwiper = new Swiper(root, {
          slidesPerView: 1.2,
          spaceBetween: 16,
          watchOverflow: true,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
          observer: true,
          observeParents: true,
          navigation: {
            prevEl,
            nextEl,
          },
          pagination: {
            el: paginationEl,
            clickable: true,
            type: 'bullets',
          },
          breakpoints: {
            [this.desktopMin]: {
              slidesPerView: deskCols,
              spaceBetween: 21,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
            },
          },
        });
      } else if (forceUpdate) {
        panel._wlsSwiper.update();
      } else {
        panel._wlsSwiper.update();
      }
    }
  }

  customElements.define('wls-testimonials', WlsTestimonials);
}
